// Merchant-controlled descriptions allow rich text formatting. Tags that could
// execute scripts or phone home are excluded: no script, no iframe, no svg, no
// form elements. The attributes allowlist in OrderDescription.tsx enforces this
// further, and link protocols are restricted to http/https/mailto to block
// javascript: URLs.
export const ALLOWED_DESCRIPTION_TAGS = ['b', 'i', 'strong', 'em', 'u', 's', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'a', 'img'];